import { Img, Text, Button } from "components";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

const EmptyAll = (props) => {
  const navigate = useNavigate();
  let list = {
    occasion: {
      image: "/images/img_order-empty.svg",
      title: t("noOccasionsSavedYet"),
      content: t("emptyOccasion"),
      showButton: false,
    },
    "custom-cake": {
      image: "/images/emptyState.png",
      title: t("noCustomCakeSavedYet"),
      content: t("emptyCustomCake"),
      showButton: true,
      buttonText: t("customizeCake"),
    },
    blogs: {
      image: "/images/img_order-empty.svg",
      title: "No blogs found",
      content: t("noBlogFound"),
      showButton: false,
    },
    recipientform: {
      image: "/images/search-icon.svg",
      title: "Link expired",
      content: t("linkExpired"),
      showButton: false,
    },
    walletHistory: {
      image: "/images/wallet.png",
      title:t("noWalletBalanceYet"),
      content: t("data_not_found"),
      showButton: true,
      buttonText: t("addBalance"),
    },
  };

  let data = list[props?.type];

  return (
    <>
      <div className="flex flex-col items-center justify-center p-12 md:p-8 sm:p-5 w-full min-h-[400px]">
        <div className="flex flex-col items-center justify-center max-w-auto w-full">
          {/* Cake Image */}
          <div className="mb-6">
            <Img
              className="h-[200px] w-auto object-contain"
              src={data?.image || "/images/img_order-empty.svg"}
              alt="empty-state"
            />
          </div>

          {/* Heading */}
          <Text className="text-[#1A1A1A] text-center font-['Unbounded'] text-[32px] leading-[48px] font-semibold mb-3">
            {data?.title || "No data available"}
          </Text>

          {/* Description */}
          <Text className="text-[#727783] text-center font-['Inter'] text-[20px] font-normal leading-[28px] mb-6">
            {data?.content || "Design your dream cake and save it for later."}
          </Text>

          {/* Button */}
          {data?.showButton && (
            <Button
              className="flex items-center justify-center gap-[10px] 
                        h-[56px] px-[64px] py-[12px] 
                        rounded-[90px] bg-[#771237] 
                        hover:bg-[#5f0e2c] transition-all duration-200"
              onClick={() => navigate("/design-my-custom-cake")}
            >
              <span className="text-[white] text-center font-['Unbounded'] text-[16px] font-medium leading-[24px]">
                {data?.buttonText || "Get Started"}
              </span>
            </Button>
          )}
        </div>
      </div>
    </>
  );
};

export default EmptyAll;
